module.exports = __webpack_public_path__ + "static/media/map-all-argentinians.29f40b04.svg";